module.exports = __webpack_public_path__ + "static/station-8d991d7e6ae7bffdcd292bb880dc47fc.png";